import { render, staticRenderFns } from "./userDashboardMembercard.vue?vue&type=template&id=f94b9f92&scoped=true"
import script from "./userDashboardMembercard.vue?vue&type=script&lang=js"
export * from "./userDashboardMembercard.vue?vue&type=script&lang=js"
import style0 from "./userDashboardMembercard.vue?vue&type=style&index=0&id=f94b9f92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94b9f92",
  null
  
)

export default component.exports